import { useEffect, useState } from "react";
import { SpanContext } from "../renditions";

export default function Debugger(props: {
  telemetrySpanContext: SpanContext
}) {
  const [clicks, setClicks] = useState(0);

  /**
   * Track clicks on background, increment counter
   */
  useEffect(() => {
    if (!props.telemetrySpanContext) return;
    const {traceId} = props.telemetrySpanContext;
    if (!traceId) return;

    const targets = [
      document.documentElement,
      document.body,
      document.getElementById('criipto_react_root'),
      document.getElementById('storybook-root'),
      document.getElementById('frame')
    ].filter(id => id !== null && id !== undefined);
    
    const listener = (event: MouseEvent) => {
      const target = event.target;
      if (target && targets.includes(target as HTMLElement)) {
        setClicks(clicks => Math.min(clicks + 1, 10));
      }
    };

    document.addEventListener('click', listener);
    return () => {
      document.removeEventListener('click', listener);
    };
  }, [props.telemetrySpanContext]);

  /**
   * Decrement counter over time
   */
  useEffect(() => {
    const interval = setInterval(() => {
      setClicks(clicks => Math.max(clicks - 1, 0));
    }, 1000);

    return () => clearInterval(interval);
  }, [setClicks]);

  /**
   * Counter listener
   */
  useEffect(() => {
    if (clicks >= 5) {
      alert(`TraceID: ${props.telemetrySpanContext?.traceId}`)
      setClicks(0);
    }
  }, [clicks, setClicks, props.telemetrySpanContext]);

  if (!props.telemetrySpanContext) return null;
  const {traceId} = props.telemetrySpanContext;
  console.debug(`TraceID: ${traceId}`);

  if (!traceId) return null;

  return null;
}